import React, { useMemo } from 'react';

import { AudioListenButton } from '@atlassian/ai-audio';

import { useAudioContentQuery } from '@confluence/audio/entry-points/useAudioContentQuery';

type AudioListenButtonWrapperProps = {
	isRovoButtonEnabled: boolean;
	contentId: string;
	contentType: string;
	spaceKey: string;
	title: string;
};

export const AudioListenButtonWrapper = ({
	isRovoButtonEnabled,
	contentId,
	contentType,
	spaceKey,
	title,
}: AudioListenButtonWrapperProps) => {
	const { data } = useAudioContentQuery({ contentId });

	const ownerName = data?.singleContent?.history?.ownedBy?.displayName;
	const authorName = data?.singleContent?.history?.createdBy?.displayName;
	const ownerAvatarUrl = data?.singleContent?.history?.ownedBy?.profilePicture?.path;
	const authorAvatarUrl = data?.singleContent?.history?.createdBy?.profilePicture?.path;
	const baseLink = data?.singleContent?.links?.base || '';
	const webuiLink = data?.singleContent?.links?.webui || '';

	const shouldUsePageOwner = ownerName && contentType === 'page';
	const contentAvatarName = shouldUsePageOwner ? ownerName : authorName;
	const contentAvatarUrl = shouldUsePageOwner ? ownerAvatarUrl : authorAvatarUrl;
	const mainContentLink = baseLink + webuiLink;
	const emojiId = data?.singleContent?.properties?.nodes?.[0]?.value;
	const subType = data?.singleContent?.subType;

	const activeContent = useMemo(
		() => ({
			contentId,
			contentType,
			subType,
			spaceKey,
			title,
			author: contentAvatarName,
			avatarUrl: contentAvatarUrl,
			supportingContent: [],
			mainContentLink: mainContentLink,
			emojiId,
		}),
		[
			contentId,
			contentType,
			subType,
			spaceKey,
			title,
			contentAvatarName,
			contentAvatarUrl,
			emojiId,
			mainContentLink
		],
	);

	return (
		<AudioListenButton
			shape={isRovoButtonEnabled ? 'default' : 'circle'}
			activeContent={activeContent}
		/>
	);
};
